// queryからメッセージID取得
export const parseMessageHistoryMessageId = (
  messageIdParam: string | string[] | undefined | null,
): number | undefined => {
  const parsed = Number(messageIdParam ?? 0);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return undefined;
  }
  return parsed;
};

// queryから日付取得（Unix ms。不正値・非有限値は undefined）
export const parseMessageHistoryFromDate = (
  fromDateParam: string | string[] | undefined | null,
): string | undefined => {
  const parsed = Number(fromDateParam ?? 0);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return undefined;
  }
  return new Date(parsed).toISOString();
};

// ファイルをダウンロード
export const doDownloadFile = (url: string, name: string): void => {
  const link = document.createElement("a");
  link.download = name;
  link.href = url;
  link.setAttribute("target", "_blank");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
